import styled from 'styled-components'
import { Button, Modal } from 'rsuite'


export const StyledQuestionsPageHeader = styled.div`
  font-family: 'Montserrat', sans-serif;
  color: #656665; 
  
  .questions-header{
    position: relative;
    background: #fff;
    display: flex;
    flex-direction: row;    
    align-items:center; 
    border: 1px solid #e3e3e3;
    align-items:center; 
    font-size: 18px;
   
    .question-info{
       
        border-right: 1px solid #e3e3e3;   
        min-height: 3em;
        padding-top: 1em;
        padding-left: 2em!important;
        align-items: center; 
        span{ font-weight: 600; }
        .info{
                color: #1d3b5d;
                font-weight: 600;
        }
        
    }
   
    .save-question{
        font-weight: 600;
        border-right: 1px solid #e3e3e3;   
        min-height: 3em;
        padding-left: 2em!important;
        align-items: center; 
        display:flex;  
        span{ font-weight: 600; }   
        label{
            font-size: 18px;
        }
    }
  }
  .review-header{
    min-height: 8em;
    display: flex;
    flex-direction: row;    
    align-items: center; 
    background: #fff;
    .info{
      flex-direction: column;
      display: flex;
      padding: 2em 0 2em 4em!important;
      h1{
      font-size: 2em!important;
      font-weight: 800!important;
      color: #0f3053;
      padding-bottom: 1em;
      }
      span{
        padding-bottom: 0.3em;
        color: #656665;
        strong{
          font-weight: 600!important;
          color: #0f3053;
        }
       
      }
    }
    
    
  }

`

/** Card de nota */
export const StyledScoreCard = styled.div`
  position: absolute;
  top: 1.5em;
  background: #fff;
  min-height: 8em;
  width: 19em;
  right: 7em;
  padding: 1em;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  display: flex; 
  -webkit-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  -moz-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  box-shadow:  0px 0px 12px -3px rgba(0,0,0,0.30);
  
  .score{
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    padding-left: 1em;
    span{
          padding-bottom: 0.3em;
          color: #0f3053;
          font-weight: 800!important;
          font-size: 1.5em;
          .text{  color: #656665; }
          strong{       
            color: #1cc9b6;
            font-size: 2.5em;
          }
      }
  }

`

/** Descrição das questões */
export const StyledQuestionDescription = styled.div`
  padding: 3em;
  font-family: 'Montserrat', sans-serif;
  min-height: 500px;
  h1{
     font-size: 18px!important;
     font-weight: 800!important;
     color: #0f3053; 
     padding-bottom: 2em;
  }
  .question-description{
     font-size: 15px!important;
     font-weight: 500!important;
     color: #868686; 
     ul{
       padding: 0.3em 1em;
       margin-left: 1em;
       list-style: circle;
     li{
      padding: 0.3em;
      }
    }
  }
  .nrt-form-input{
    padding: 3em 0;
    font-size: 14px!important;
    font-family: 'Montserrat', sans-serif;
    span{
      font-weight: 500!important;
      color: #868686; 
      }
  }
  .nrt-radio-button:before{
    background: #e8e8e8;
    border: none;
  }
  .nrt-radio-button:after{
    background: #0f3053;
  }
  .nrt-form-input textarea{
      border: none;
      border-radius: 10px;
      min-height: 200px;
      box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.1);
  }
  .nrt-ead-question-truefalse{
    p{
      font-size: 15px!important;
      font-weight: 500!important;
      color: #868686;
    }
    
    .nrt-form-input{
      padding: 1em 0;
    }
  }
`

/** Botões de navegação do rodapé */
export const StyledButton = styled(Button)`
  border-radius: 80px!important;
  padding: ${(props) => props.color === 'blue' ? '1em 2em 1em 2em!important;' : (props.color === 'green' && props.appearance === 'defaut' ? '1em 2em 1em 3em!important;' : '1em 3em 1em 2em!important;')};   
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  margin-left: 2em;
  color: ${(props) => props.color === 'blue' ? '#0f3053' : (props.color === 'green' && props.appearance === 'defaut' ? ' #fff' : '#cacaca')};  
  background: ${(props) => props.color === 'green' && props.appearance === 'defaut' ? ' #1cc9b6' : '#fff'};  
  border: ${(props) => props.color === 'blue' ? '2px solid  #0f3053' : (props.appearance !== 'ghost' ? 'none' : '1px solid #cacaca')};
  &:hover{
    color: ${(props) => props.color === 'blue' ? '#ffffff' : (props.color === 'green' && props.appearance === 'defaut' ? ' #fff' : '#cacaca')};  
    background: ${(props) => props.color === 'blue' ? '#0f3053' : (props.color === 'green' && props.appearance === 'defaut' ? ' #0f3053' : '#fff')};  
    border: ${(props) => props.color === 'blue' ? 'none' : (props.appearance !== 'ghost' ? 'none' : '1px solid #868686')};
  }
  &:focus{
    color: ${(props) => props.color === 'blue' ? '#ffffff' : (props.color === 'green' && props.appearance === 'defaut' ? ' #fff' : '#cacaca')};  
    background: ${(props) => props.color === 'blue' ? '#0f3053' : (props.color === 'green' && props.appearance === 'defaut' ? ' #0f3053' : '#fff')};  
    border: ${(props) => props.color === 'blue' ? 'none' : (props.appearance !== 'ghost' ? 'none' : '1px solid #868686')};
  }

  i{
    padding: 0 9px;
  }
  
`
/** Containder de navegação lateral */
export const StyledQuestionNavigationContainer = styled.div`
  position: relative;
  top: 2em;
  background: #fff;
  min-height: 400px;
  width: 300px;
  border-radius: 20px; 
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  -moz-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  .navigation{
    margin: 0 auto;
    padding-top: 1em;
    position:relative;
    .box-title{
        font-family: 'Montserrat', sans-serif;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px!important;
        font-weight: 600!important;
        padding-bottom: 1.3em;
        color: #0f3053!important; 
        border-bottom: 1px solid #eeeeee;
        &::after{
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 8em;
            height: 0.2em;
            border-radius: 10px;
            background: #1cc9b6;
        }
    }
 }
 .navigation-buttons{
     position: relative;
     display: flex;
     flex-wrap: wrap;
     padding: 1em;
     justify-content: center;
 }
  .send-answers{
     margin: .5rem 0;
     display: flex;
     justify-content: center;
     align-items: center;
     bottom: 1em;
     left: 0;
     right: 2em;
 }
  .timer{
    width: 100%;
    bottom: 6em;
  }
  
`
/** Containder de resumo de respostas */
export const StyledTimerBox = styled.div`
  background: #fafafa;
  padding: 0 1em;
  min-height: 4em;
  display: flex;
  align-items: center;
  font-size: 1.3em;
  font-weight: 800; 
  color: #9f9f9f;
  position: ${(props) => props.isSummary && 'absolute'};    
  bottom:${(props) => props.isSummary && '-20em'};
  left: ${(props) => props.isSummary && '2em'};
  
  .coundown-box{
    background: #f0f0f0;
    margin: 0 0.4em;
    padding: 0.7em; 
    border-radius: 0.5em;  
    font-size: 1em;
    font-weight: 800; 
    color: #9f9f9f; 
  }
  .row{
    display: flex;
    align-items: center;

    .icon{    
      border-right: 1px solid #eeeeee;
      margin-right: 1em;
      padding: 0px 1em 0 1em;
    }
  }

`

/** Containder de resumo de respostas */
export const StyledSummaryContainer = styled.div`
display: ${props => props.flex && 'flex'};
    justify-content: space-around;
.previous-tries-header{
    top: 6em;
    padding: 1em 4em;
    position: relative;
    font-weight: 600;
    color: #0f3053;
 }

.previous-tries{
  
   position: relative;
   top: 6em;
   padding-bottom: 2em;
   font-weight: 600;
   color: #868686;
   .subtitle{
      padding-left: 5em;
      font-size: 15px;
      color: #113154;
      top: 11em;
      position: absolute;
      span{
        padding-right: 3em; 
        font-weight: 600;
      }
    }
    .card{
      width: auto;
      max-width: 90%;
      min-height:15em;
      padding: 1em 0em;
      top: 0;
      left: 3em;
      .rs-flex-box-grid-space-around{
        width: 100%;
        padding: 1em 0em;
        border-bottom: 1px #fafafa solid;
      }
      .score{
          color: #0f3053;      
      }
      .submision{
        color: #0f3053;   
      }
      .rs-flex-box-grid-item {
        font-weight: 600;
        .rs-btn {
          padding: 0.5em 0.8em 0.5em 0.8em!important;
          margin-left: 0;
        }
          span{
             color: #e38a8a;
             font-size: 21px;
             font-weight: 800;
          }    
      }
    }
 }
.buttons {
  bottom: -25rem !important;
  position: absolute !important;
  margin: 1rem 10rem !important;
}
.timer {
  margin: 3rem 2rem !important;
  position: absolute !important;
  bottom: -22rem !important;
}
.summary-title{
   width: 70%;
   justify-content: flex-start;

    h1{
    color: #0f3053;
    position: absolute;
    top: 1em;
    left: 1.2em;
    font-size: 3em;
    font-weight: 900;
    }
    span{
      font-weight: 400;
    }
    p{
      padding-left: 3em;
      font-size: 18px;
      color: #0f3053;
      top: 5.5em;
      position: absolute;
    }
 }

  .subtitle{
    padding-left: 3em;
    font-size: 18px;
    color: #716d71;
    top: 9.5em;
    position: absolute
    span{
      padding-right: 2em;
    }
  }
 .card{
  position: relative;
  top: 15em;
  padding: 1em 3em;
  background: #fff;
  min-height: 400px;
  width: 400px;
  border-radius: 20px; 
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  -webkit-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  -moz-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
   .status{    
     display: flex;
     align-items: center;
     padding-top: 0.5em;
     .text-status{
        padding-left: 3em;
        font-size: 18px;
        color: #716d71;
     }
  }
 }
 .rs-row{
    margin-left: -5px;
    margin-right: -5px;
    position: absolute;
    bottom: -32em;
    width: 100%;
 }

  
`

export const StyledQuestionButtonNavigate = styled.div`
   background:  ${(props) => props.isCorrect === null ? (props.isAnswered ? '#a9c4e0' : '#f0f0f0') : (props.isCorrect ? '#98e0d8' : '#f8c9c9')}; 
   color: ${(props) => props.isCorrect === null ? (props.isAnswered ? '#6591bf' : (props.isCurrent ? '#0f3053' : (props.item && props.item.success ? ' #4e918a;' : '#9f9f9f'))) : (props.isCorrect ? '#4f928b' : '#d7818d')}; 
   border: ${(props) => props.isCurrent ? '2px solid #0f3053' : 'none'}; 
   font-size: 12px;
   font-weight: 800!important;
   padding: 0.8em 1em;
   margin: 0.3em;
   border-radius: 7px;
   display: flex;
   align-items: center;
   width: 2.5rem;
   cursor: pointer;
   position: relative;
   &::before{
      content: '';
      position: absolute;
      top: 0;
      right: 3px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 10px solid #0f3053;
      display: ${(props) => props.isSaved ? 'block' : 'none'}; 
   }

`
/** Card de informacoes do questionario */
export const StyledQuestionaryInfoCard = styled.div`
  position: relative;
  background: #fff;
  min-height: 18em;
  top: 2em;
  left: 2em;
  width: 90%;
  border-radius: 10px; 
  display: flex;
  align-items: center;
  -webkit-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  -moz-box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);
  box-shadow: -5px 7px 32px -10px rgba(0,0,0,0.15);

  .description-col{
    width: 70%;
    justify-content: flex-start;

    h1{
    color: #0f3053;
    position: absolute;
    top: 1em;
    left: 1em;
    font-size: 2em;
    font-weight: 900;
    span{
      font-weight: 400;
    }
  }

  }
  .info{
    width: 30%;
    flex-direction: column;
    background: #f8f8f8;
    min-height: 20em;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
    &:not(.no-time)::after{
      position: absolute;
      content: '';
      top: 10em;
      width: 75%;
      height: 1px;
      background: #e5e5e5;
      right: 0;
      left: 0;
      margin: 0 auto;
    }
  }
  .description-text{
     display: flex;
     flex-direction: column;
     justify-content: flex-start;  
     padding-left: 2em;   
     padding-right: 2em;  
     p{
        color: #0f3053;
        font-size: 16px;
        padding: 2em 18em 2em 0em;
        position: absolute;
        top: 4em;
     }
  }
  .rs-btn{   
    bottom: 2em;
    position: absolute;
    padding: 1.2em 1em;
  }
  .questions-info{
    font-size: 14px;
    color: #0f3053;   
    text-align: center;
    text-transform: uppercase;
    font-weight: 500;
    padding-bottom: 1em;
    position: relative;

    span{
      margin-bottom: 0.3em;
      font-size: 5em;
      font-weight: 800;
     
    }

  }
  .duration-info{
    font-size: 14px;
    color: #0f3053;   
    text-align: center;
    text-transform: uppercase;
    font-weight: 500;
    padding-top: 1em;
    span{
      margin-bottom: 0.3em;
      font-size: 5em;
      font-weight: 800;
    }
  }

` 
/** Modal de confirmacao */
export const StyledConfirmModal = styled(Modal)`

display: flex;
justify-content: center;
flex-direction: column;
position: absolute;
top: 10em;
bottom: 0;
left: 20em!important;
right: 0;
align-items: center;
min-height: 30em;
border-top
p{
  font-size: 18px!important;
  font-weight: 600!important;
  color: #9f9f9f; 
  text-align: center;
  line-height: 1em;
 
}
.modal-body{
  font-size: 18px!important;
  font-weight: 600!important;
  color: #9f9f9f; 
  text-align: center;
  line-height: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  strong{
    color: #0f3053;
    font-weight: 800!important;
  }
  svg{
    margin-bottom: 1em;

  }
}
.modal-footer{  
  display: flex;
  flex-direction: row-reverse;
  .rs-btn{       
    border-radius: 5px!important;
    padding: 0.7em 1em!important;
    font-size: 16px!important;
  }
}


`
export const StyledQuestionAnswers = styled.li`

  font-size: 14px!important;
  font-weight: 500!important;
  color: #868686; 
  padding: 0.7em 1em;
  border-radius: 1em;
  margin-top: 1.5em;
  margin-left: 1.5em;
  list-style: none;
  color: ${(props) => props.isCorrect ? '#458981' : (props.isAnswer ? '#dd2f44' : '#808080') }; 
  background: ${(props) => props.isCorrect ? '#98e1d9' : 'none' }; 
  position: relative;
   &::before{
      content: '';
      position: absolute;
      top: 0.8em;
      left: -2em ;
      width: 0.8em;
      height: 0.8em;
      border-radius: 2em;
      background: ${(props) => props.isCorrect ? '#458981' : (props.isAnswer ? '#dd2f44' : 'none') };      
      display: ${(props) => props.isCorrect || props.isAnswer ? 'block' : 'none'}; 
   }


`

export const StyledCommentBox = styled.li`

  background: #F5F6CE;
  border: 1px solid #F7D358;
  border-radius: 1em;
  display: block;
  padding: 10px; 
  margin-bottom: 10px; 
`



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/styled/StyledQuestionComponents.js